export default __webpack_public_path__ + "static/media/green_mark_icon.3f962217.svg";